module.exports = __webpack_public_path__ + "static/media/iMessage.57ccf920.png";